// components/PageWrapper.jsx
import { motion } from "framer-motion";

const variants = {
  initial: { opacity: 0, y: -100, scale: 1.1 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.16, // etwas flüssiger
      duration: 0.55,
      ease: "easeInOut"
    }
  },
  exit: { opacity: 0, y: 100, scale: 1.05, transition: { duration: 0.4 } }
};

const childVariants = {
  initial: { opacity: 0, y: 20, filter: "blur(8px)" },
  animate: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      filter: { duration: 0.36 },
      y: { duration: 0.44 },
      opacity: { duration: 0.4 }
    }
  },
  exit: { opacity: 0, y: 100, filter: "blur(100px)", transition: { duration: 0.25 } }
};

export default function PageWrapper({
  children,
  className = "",
  style = {},
  animateChildren = true, // neuer prop
  layout = false, // nur bei Bedarf aktivieren!
  ...rest
}) {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      className={`relative ${className}`}
      style={style}
      {...(layout ? { layout } : {})}
      {...rest}
    >
      {Array.isArray(children)
        ? children.map((child, i) =>
            animateChildren ? (
              <motion.div key={child?.key ?? i} variants={childVariants}>
                {child}
              </motion.div>
            ) : (
              <>{child}</>
            )
          )
        : animateChildren ? (
            <motion.div variants={childVariants}>{children}</motion.div>
          ) : (
            <>{children}</>
          )}
    </motion.div>
  );
}
